<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/j0JaCn/tc-custom/9780062281401.jpg?1740867011769" alt="This image is the cover for the book Robert Plant"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Robert Plant
      </h1>
      <p class="bookDescription body article font2">
        <b>This biography of the solo artist and legendary lead singer of Led Zeppelin “informs and entertains . . . leav[ing] few stones in Plant’s life unturned.” —<i>Mojo</i> magazine</b><br/><br/><i>Robert Plant</i> by Paul Rees is the definitive biography of Led Zeppelin's legendary frontman. As lead singer for one of the biggest and most influential rock bands of all time—whose song “Stairway to Heaven” has been played more times on American radio than any other track—Robert Plant defined what it means to be a rock god.<br/><br/>Over the course of his twenty-year career, British music journalist and editor Paul Rees has interviewed such greats as Sir Paul McCartney, Bruce Springsteen, Madonna, Bono, and AC/DC. Rees now offers a full portrait of Robert Plant for the first time, exploring the forces that shaped him, the ravaging highs and lows of the Zeppelin years—including his relationship with Jimmy Page and John Bonham—and his life as a solo artist today.<br/><br/>Illustrated with more than two dozen photographs, <i>Robert Plant: A LIfe</i> is the never-before-told story of a gifted, complicated music icon who changed the face of rock 'n' roll.<br/><br/>“Anyone seeking insight into Robert Plant as a man and musician will find it here.” —<i>Q </i>Magazine<br/><br/>“Particularly enlightening on Plant’s formative pre-Zep years in the Midlands, <i>A Life</i> puts the singer’s eclectic career into clear context.” —Dave Lewis, <i>Tight But Loose</i> magazine
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Paul Rees
      </h2>
      
      <p class="authorDescription body article"><P>Paul Rees has written about music for more than twenty years. He has interviewed everyone from Paul McCartney, Bruce Springsteen, and Madonna to Bono, Take That, and AC/DC. His work has appeared in many publications, including the <I>Sunday Times Culture</I>, the <I>Telegraph</I>, the <I>Independent</I>, and the <I>Evening Standard</I>. He was also editor of two of the UK&#39;s most successful and long-standing music publications, <I>Q</I> magazine and <I>Kerrang!</I>, for a total of twelve years. He lives in England.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ec4e1508